<div
  class="doc-sidebar gw-flex gw-flex-col gw-items-start gw-bg-background-base gw-transition-all gw-duration-300 gw-ease-in-out gw-shrink-0 gw-h-full gw-border-r gw-border-border-normal"
  [class.doc-sidebar-collapsed]="isCollapsed"
  [class.doc-sidebar-expanded]="!isCollapsed"
>
  <div
    class="doc-sidebar-header gw-bg-background-neutral-1 gw-flex gw-items-center gw-justify-between gw-w-full gw-px-medium gw-py-x-small gw-shrink-0 gw-box-border gw-border-b gw-border-border-normal"
  >
    <span
      *ngIf="!isCollapsed"
      class="gw-text-sm gw-font-bold gw-text-text-secondary gw-truncate"
    >
      Base de conhecimento
    </span>
    <button
      type="button"
      class="gw-flex gw-items-center gw-justify-center gw-min-h-[32px] gw-min-w-[32px] gw-rounded-lg gw-b-none gw-bg-transparent gw-cursor-pointer gw-text-text-secondary hover:gw-bg-background-neutral-1-hover"
      (click)="toggleCollapse()"
      aria-label="Toggle documentation navigation"
    >
      <gatewee-icon
        [icon]="isCollapsed ? '@phi.caret-right' : '@phi.caret-left'"
        size="16px"
      />
    </button>
  </div>

  <nav
    class="doc-sidebar-nav gw-flex gw-flex-col gw-flex-1 gw-w-full gw-overflow-y-auto gw-overflow-x-hidden gw-py-medium"
    aria-label="Documentation navigation"
  >
    <gatewee-doc-sidebar-node [items]="items" [depth]="0" [sidebar]="this" />
  </nav>
</div>
